import Defaults from '~/scripts/constants/defaults';

export default class ModalConfirmUpdateController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} items
	 */
	constructor($translate, $uibModalInstance, items) {
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.items = items;
		this.actions = [];

		this.keysToCheck = [
			'LINK_LIST',
			'DROIT_LIST',
			'DROITCUST_LIST',
			'DROITDEF_LIST',
			'REPRE_LIST',
			'kjson',
			'kndef',
			'kndefext',
			'type_kid',
			'_droit_force_',
			'_droitdef_force_',
		];

		this.actionToIcon = (/** @type {string} */ type) => {
			switch (type) {
			case 'ADD': {
				return '<i class="fa fa-plus-circle"></i>';
			}
			case 'MOD': {
				return '<i class="fa fa-pencil"></i>';
			}
			case 'DEL': {
				return '<i class="fa fa-minus-circle"></i>';
			}

			default: {
				return type;
			}
			}
		};

		for (const item of items) {
			this.actions.push(this.itemToAction(item));
		}
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	/**
	 * @param {number} rightsAsNumber
	 * @returns {any}
	 */
	decodeRights(rightsAsNumber) {
		return {
			create: !!(rightsAsNumber & Defaults.DROIT.CREATE),
			read:   !!(rightsAsNumber & Defaults.DROIT.READ),
			update: !!(rightsAsNumber & Defaults.DROIT.MODIFY),
			delete: !!(rightsAsNumber & Defaults.DROIT.DELETE),
		};
	}

	/**
	 * @param {any} _item
	 * @returns {any}
	 */
	itemToAction(_item) {
		const action = [];
		const nodeInfos = [];

		const targetName = _item.target_objnum;
		const item = _item.OBJECT_LIST[targetName];

		for (const key of Object.keys(item)) {
			// TODO it should be better to use infos from original content
			// Deleted elements only give access to some properties like "kid"
			// Which is not user-friendly
			switch (key) {
			case 'ATTRIBUT_LIST': {
				for (const attribute of item.ATTRIBUT_LIST) {
					if (attribute.action) {
						let value = '';
						value = attribute.action === 'DEL'
							? `${this.actionToIcon(attribute.action)} ${attribute.kid}`
							: `${this.actionToIcon(attribute.action)} ${attribute.name}:${attribute.ref_type} ${attribute.value}`;
						action.push({
							key: 'Attributs',
							value,
						});
					}
				}
				break;
			}
			case 'LINK_LIST': {
				for (const relations of Object.entries(item.LINK_LIST)) {
					for (const relation of relations[1]) {
						if (relation.action) {
							action.push({
								key:   'Relations',
								value: `${this.actionToIcon(relation.action)} ${relation.relation_kid} ${relation.objnum2}`,
							});
						}
					}
				}
				break;
			}
			case 'DROIT_LIST': {
				for (const droit of item.DROIT_LIST) {
					if (droit.action) {
						action.push({
							key:   this.$translate.instant('right.droit-title'),
							value: `${this.actionToIcon(droit.action)} ${droit.role_kid}: ${this.rightToString(droit.kright)}`,
						});
					}
				}
				break;
			}

			case 'DROITCUST_LIST': {
				for (const droitcust of item.DROITCUST_LIST) {
					if (droitcust.action) {
						let value = this.actionToIcon(droitcust.action);

						if (droitcust.kid) {
							value += ` kid=${droitcust.kid}`;
						}

						if (droitcust.order) {
							value += ` order=${droitcust.order}`;
						}

						if (droitcust.suborder) {
							value += ` suborder=${droitcust.suborder}`;
						}

						if (droitcust.role_kid) {
							value += ` role_kid=${droitcust.role_kid}`;
						}

						if (droitcust.org_kid) {
							value += ` org_kid=${droitcust.org_kid}`;
						}

						if (droitcust.kright) {
							value += ` kright=${droitcust.kright}`;
						}

						action.push({
							key:   this.$translate.instant('right.droitcust-title'),
							value,
						});
					}
				}
				break;
			}

			case 'DROITDEF_LIST': {
				for (const droitdef of item.DROITDEF_LIST) {
					if (droitdef.action) {
						let value = this.actionToIcon(droitdef.action);

						if (droitdef.kid) {
							value += ` kid=${droitdef.kid}`;
						}

						if (droitdef.order) {
							value += ` order=${droitdef.order}`;
						}

						if (droitdef.suborder) {
							value += ` suborder=${droitdef.suborder}`;
						}

						if (droitdef.role_kid) {
							value += ` role_kid=${droitdef.role_kid}`;
						}

						if (droitdef.org_kid) {
							value += ` org_kid=${droitdef.org_kid}`;
						}

						if (droitdef.kright) {
							value += ` kright=${droitdef.kright}`;
						}

						action.push({
							key:   this.$translate.instant('right.droitdef-title'),
							value,
						});
					}
				}
				break;
			}

			case 'REPRE_LIST': {
				for (const repre of item.REPRE_LIST) {
					if (repre.action) {
						const value = repre.action === 'DEL'
							? `${this.actionToIcon(repre.action)} ${repre.lang.name}`
							: `${this.actionToIcon(repre.action)} ${repre.lang.name}: ${repre.name}`;
						action.push({
							key: 'Représentations',
							value,
						});
					}
				}
				break;
			}
			case 'kjson': {
				nodeInfos.push({
					key: 'Nœud',
					value: `${this.actionToIcon('MOD')} KJSON mis à jour`,
				});
				break;
			}
			case 'kndef': {
				nodeInfos.push({
					key: 'Nœud',
					value: `${this.actionToIcon('MOD')} Définition mise à jour`,
				});
				break;
			}
			case 'kndefext': {
				nodeInfos.push({
					key: 'Nœud',
					value: `${this.actionToIcon('MOD')} Définition personnalisée mise à jour`,
				});
				break;
			}
			case 'type_kid': {
				if (item.action) {
					nodeInfos.push({
						key:   'Nœud',
						value: `${this.actionToIcon(item.action)} Type: ${item.type_kid}`,
					});
				}
				break;
			}
			case '_droit_force_': {
				nodeInfos.push({
					key:   'Nœud',
					value: `Droits forcés sur "${item[key]}"`,
				});
				break;
			}
			case '_droitdef_force_': {
				nodeInfos.push({
					key:   'Nœud',
					value: `Droits de définition forcés sur "${item[key]}"`,
				});
				break;
			}
			default:
			}
		}

		if (nodeInfos.length > 0) {
			action.unshift(...nodeInfos);
		}

		const summary = Object.entries(
			// eslint-disable-next-line unicorn/prefer-object-from-entries,unicorn/no-array-reduce
			action.reduce((/** @type {any} */ accumulator, current) => {
				if (!accumulator[current.key]) {
					accumulator[current.key] = [];
				}
				accumulator[current.key].push(current.value);
				return accumulator;
			}, {}),
		).map(entry => {
			const key = entry[0];
			const value = entry[1];
			return `<b>${key}</b>:\n${value.map((/** @type {any} */ v) => `\t${v}`).join('\n')}\n`;
		});

		return summary.join('<hr>');
	}

	submit() {
		this.$uibModalInstance.close();
	}

	/**
	 * @param {any} r
	 * @returns {string}
	 */
	rightToString(r) {
		const right = this.decodeRights(r);

		/** @type {any} */
		const rights = {
			create: 'Créer',
			read:   'Lire',
			update: 'Modifier',
			delete: 'Supprimer',
		};

		const rightsString = [];
		for (const entry of Object.entries(right)) {
			const rightName = entry[0];
			const exist = entry[1];

			if (exist) {
				rightsString.push(rights[rightName]);
			}
		}
		const joinedString = rightsString.join(', ');
		if (joinedString === '') {
			return 'Aucun';
		}
		return joinedString;
	}
}
